import {
    putAndHandleAPIError,
    putAndWaitHandleAllAPIError
} from '@api/API.sagas';
import {
    API_GET_DRAW_DOWN_REPAYMENT_SCHEDULE,
    API_GET_DRAW_DOWN_REPAYMENT_SCHEDULE_SUCCESS,
    API_PUT_APPLICATION
} from '@api/lendingAPI/LendingAPI.actions';
import { getCountry } from '@iwIntlProvider/CountryProvider';
import { REQUEST_CHANGE_ROUTER } from '@iwRouter/IwRouter.actions';
import { fork, put, take, takeLatest } from 'redux-saga/effects';

import * as actions from './MyOffers.actions';

export const MY_OFFERS_URL = '/my-offers/';

export const myOffersSagaWorkers = [
    fork(requestNewDrawdownRepaymentScheduleWorker),
    fork(declinedReapplyWorker)
];

function* requestNewDrawdownRepaymentScheduleWorker() {
    yield takeLatest(
        actions.REQUEST_DRAW_DOWN_REPAYMENT_SCHEDULE,
        function* (action) {
            const { formalOffer, amount } = action;
            yield putAndWaitHandleAllAPIError([
                {
                    type: API_GET_DRAW_DOWN_REPAYMENT_SCHEDULE,
                    productType: formalOffer.product_type,
                    offerId: formalOffer.offer_id,
                    amount
                }
            ]);

            yield take(API_GET_DRAW_DOWN_REPAYMENT_SCHEDULE_SUCCESS);
        }
    );
}

function* declinedReapplyWorker() {
    yield takeLatest(actions.DECLINED_APPLICATION_REAPPLY, function* (action) {
        const { currentRequestedProduct } = action;

        const isDe = getCountry() === 'DE';

        const durationDataDE = {
            duration: currentRequestedProduct.duration
        };

        const PUTApplicationData = {
            data: {
                requested_products: [
                    {
                        product_type: currentRequestedProduct.product_type,
                        amount: currentRequestedProduct.amount,
                        purpose: currentRequestedProduct.purpose,
                        ...(isDe && durationDataDE)
                    }
                ]
            }
        };

        yield putAndHandleAPIError({
            type: API_PUT_APPLICATION,
            body: JSON.stringify(PUTApplicationData)
        });

        yield put({
            type: REQUEST_CHANGE_ROUTER,
            location: { pathname: '/' }
        });
    });
}
